import store from '@/store/index'

// userInfo 저장
function saveUserToStorage(value) {
  localStorage.setItem('userInfo', JSON.stringify(value.userInfo))
  localStorage.setItem('userToken', JSON.stringify(value.userToken))
  localStorage.setItem('refreshToken', JSON.stringify(value.refreshToken))
}

function saveTokenToStorage(value) {
  console.log(value.userToken)

  store.commit('SET_USER_TOKEN', value.userToken)
  store.commit('SET_REFRESH_INFO', value.refreshToken)
  localStorage.setItem('userToken', JSON.stringify(value.userToken))
  localStorage.setItem('refreshToken', JSON.stringify(value.refreshToken))
}

// userInfo 조회
function getUserFromStorage() {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo !== 'undefined') {
    return JSON.parse(userInfo)
  } else {
    return ''
  }
}

// userToken 조회
function getUserToken() {
  const userToken = localStorage.getItem('userToken')
  if (userToken !== 'undefined') {
    return JSON.parse(userToken)
  } else {
    return ''
  }
}

// refreshToken 조회
function getRefreshToken() {
  const refreshToken = localStorage.getItem('refreshToken')
  if (refreshToken !== 'undefined') {
    return JSON.parse(refreshToken)
  } else {
    return ''
  }
}

// userInfo 삭제
function deleteUserStorage() {
  localStorage.removeItem('userInfo')
  localStorage.removeItem('userToken')
  localStorage.removeItem('refreshToken')
}

// state를 localStorage에 저장
function saveStateToStorage(name, item) {
  localStorage.setItem(name, item)
}

// state를 localStorage에 조회
function getStateToStorage(name) {
  return localStorage.getItem(name)
}

// state를 localStorage에 삭제
function deleteStateToStorage(name) {
  localStorage.removeItem(name)
}

// 최근검색어 저장
function saveSearchWordToStorage(searchWord) {
  const item = localStorage.getItem('recentKeyword')
  var recentKeyword = []
  if (item === null) {
    // 최근검색어가 없으면
    recentKeyword = [searchWord]
  } else {
    // 최근 검색어가 있으면
    recentKeyword = JSON.parse(item)

    // 동일한 검색어가 있는지 확인하고 있다면 삭제
    var index = recentKeyword.indexOf(searchWord)
    if (index !== -1) {
      recentKeyword.splice(index, 1)
    }

    if (recentKeyword.length >= 10) {
      // 최근검색어가 10개 이상이면
      recentKeyword.shift()
    }

    // 받아온 검색어 추가
    recentKeyword.push(searchWord)
  }
  localStorage.setItem('recentKeyword', JSON.stringify(recentKeyword))
}

// 최근검색어 삭제
function deleteSearchWordToStorage() {
  localStorage.removeItem('recentKeyword')
}

// 최근검색어 1개 삭제
function deleteOneSearchWordToStorage(searchWord) {
  const item = localStorage.getItem('recentKeyword')
  if (item !== null) {
    // 최근 검색어가 있는 경우
    let recentKeyword = JSON.parse(item)

    const index = recentKeyword.indexOf(searchWord)
    if (index !== -1) {
      // 검색어가 목록에 있는 경우
      recentKeyword.splice(index, 1) // 해당 검색어 삭제
      localStorage.setItem('recentKeyword', JSON.stringify(recentKeyword)) // 업데이트된 목록을 다시 로컬스토리지에 저장
    }
  }
}

export {
  saveUserToStorage,
  saveTokenToStorage,
  getUserFromStorage,
  getUserToken,
  getRefreshToken,
  deleteUserStorage,
  saveStateToStorage,
  getStateToStorage,
  deleteStateToStorage,
  saveSearchWordToStorage,
  deleteSearchWordToStorage,
  deleteOneSearchWordToStorage,
}
